function hasLocalStorage() {
  try {
    const key = '__test_key__';
    localStorage.setItem(key, key);
    localStorage.removeItem(key);
    return true;
  } catch (_e) {
    return false;
  }
}

const memoryStorage: Record<string, string> = {};

const setItem = (key: string, value: string) => {
  if (hasLocalStorage()) {
    localStorage.setItem(key, value);
  }
  memoryStorage[key] = value;
};

const getItem = (key: string) => {
  if (hasLocalStorage()) {
    return localStorage.getItem(key);
  }
  return memoryStorage[key];
};

const removeItem = (key: string) => {
  if (hasLocalStorage()) {
    localStorage.removeItem(key);
  }
  delete memoryStorage[key];
};

const local = {
  setItem,
  getItem,
  removeItem,
};

export { local };
